
interface ContactProps {
  onApplyClick: () => void;
}

export default function Contact({ onApplyClick }: ContactProps) {
  return (
    <section id="contact" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="bg-gradient-to-br from-pink-50 via-white to-pink-50 rounded-3xl p-8 sm:p-16 border border-pink-100 shadow-xl">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-pink-400 to-pink-500 rounded-full mx-auto mb-6 shadow-lg">
              <i className="ri-chat-heart-line text-4xl text-white"></i>
            </div>

            <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4">
              応募・お問い合わせ
            </h2>
            <p className="text-gray-600 text-base mb-8 leading-relaxed">
              まずはお気軽にご相談ください。<br />
              LINEで簡単に応募・お問い合わせができます。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <button
                onClick={onApplyClick}
                className="w-full sm:w-auto bg-[#06C755] text-white px-10 py-4 rounded-full text-base font-bold hover:bg-[#05b34c] transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-line-fill text-xl mr-2"></i>
                LINEで応募する
              </button>
              <a
                href="tel:0662118873"
                className="w-full sm:w-auto bg-white text-gray-800 px-10 py-4 rounded-full text-base font-bold hover:bg-gray-50 transition-all shadow-lg border-2 border-gray-200 whitespace-nowrap cursor-pointer inline-block text-center"
              >
                <i className="ri-phone-line text-xl mr-2"></i>
                電話で問い合わせ
              </a>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-left">
              <div className="bg-white p-6 rounded-xl border border-pink-100">
                <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-xl mb-4">
                  <i className="ri-time-line text-2xl text-pink-500"></i>
                </div>
                <h3 className="font-bold text-gray-800 text-sm mb-2">受付時間</h3>
                <p className="text-gray-600 text-sm">11:00〜25:00<br />年中無休</p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-pink-100">
                <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-xl mb-4">
                  <i className="ri-chat-smile-3-line text-2xl text-pink-500"></i>
                </div>
                <h3 className="font-bold text-gray-800 text-sm mb-2">LINE対応</h3>
                <p className="text-gray-600 text-sm">24時間受付<br />即日返信</p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-pink-100">
                <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-xl mb-4">
                  <i className="ri-shield-check-line text-2xl text-pink-500"></i>
                </div>
                <h3 className="font-bold text-gray-800 text-sm mb-2">秘密厳守</h3>
                <p className="text-gray-600 text-sm">個人情報は<br />厳重に管理</p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-pink-100 sm:col-span-3">
                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 text-center sm:text-left">
                  <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-xl flex-shrink-0 mx-auto sm:mx-0">
                    <i className="ri-map-pin-line text-2xl text-pink-500"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-gray-800 text-sm mb-2">アクセス</h3>
                    <p className="text-gray-600 text-sm mb-2">大阪市中央区千日前1-9-12 4階</p>
                    <a href="https://share.google/OELCFkaWPVei1iCA4" target="_blank" rel="noopener noreferrer" className="text-pink-500 text-xs font-bold hover:underline">
                      Google Maps <i className="ri-external-link-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="mt-16 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex flex-col items-center md:items-start gap-2">
              <div className="flex items-center gap-3">
                <img
                  src="https://static.readdy.ai/image/38c616fd8ccf1a8e3e37c843eeb88e31/7e733299bbff473d8f94beaff4f3770b.png"
                  alt="咲くら庵"
                  className="h-16 w-auto object-contain"
                />
              </div>
              <div className="text-sm text-gray-500 text-center md:text-left">
                <p>〒542-0074 大阪府大阪市中央区千日前１丁目９−１２ 4階</p>
                <p>TEL: 06-6211-8873</p>
              </div>
            </div>
            <p className="text-sm text-gray-500">
              © 2025 咲くら庵. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-pink-500 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </footer>
      </div>
    </section>
  );
}
